// src/hooks/useLocationLabels.js
import { useEffect, useState, useCallback } from 'react';
import api from '../api/api';
import { ENDPOINTS } from '../api/endpoints';

function parseLocationCodes(str) {
  str = str || "";
  const codes = [];
  let i = 0;
  while (i < str.length) {
    const third = str.charAt(i + 2);
    if (third && /\d/.test(third)) {
      codes.push(str.substr(i, 3));
      i += 3;
    } else {
      codes.push(str.substr(i, 2));
      i += 2;
    }
  }
  return codes;
}

export function useLocationLabels() {
  const [labelMap, setLabelMap] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;

    async function fetchLabels() {
      try {
        const response = await api.get(ENDPOINTS.getLocations());
        const all = response.data?.data || [];

        const stateCounts = all.reduce((counts, loc) => {
          const state = (loc.locationState || "").trim().toLowerCase();
          if (state) {
            counts[state] = (counts[state] || 0) + 1;
          }
          return counts;
        }, {});

        const map = {};

        all.forEach(({ locationCode, locationState, locationCity }) => {
          const code = locationCode?.trim();
          const state = (locationState || "").trim();
          const city = (locationCity || "").trim();
          const stateKey = state.toLowerCase();

          if (code && state) {
            map[code] =
              stateCounts[stateKey] > 1 &&
              city &&
              city.toLowerCase() !== stateKey
                ? `${state} (${city})`
                : state;
          }
        });

        if (mounted) {
          setLabelMap(map);
          setLoading(false);
        }
      } catch (err) {
        console.error("Failed to fetch location labels:", err);
        if (mounted) {
          setError(err);
          setLoading(false);
        }
      }
    }

    fetchLabels();

    return () => {
      mounted = false;
    };
  }, []);

  const formatLocations = useCallback(
    (codeString) => {
      const codes = parseLocationCodes(codeString);
      return codes.map((code) => labelMap[code] || code).join(', ');
    },
    [labelMap]
  );

  return { loading, error, formatLocations };
}